export const BUTTON = {
  SAVE_EDITS: "حفظ التعديلات",
};

export const FORM = {
  ADDRESS_DETAIL: "تفاصيل العنوان",
  CITY: "المدينة",
  NEIGHBORHOOD: "الحي",
  STREET: "الشارع",
  BUILDING_NUMBER: "رقم المبني",
  POST_NUMBER: "الرقم البريدي",
};
